import {bootstrapApplication} from '@angular/platform-browser';
import {config} from './app/app.config';
import {AppComponent} from './app/app.component';
import {environment} from "./environments/environment";
import {enableProdMode} from "@angular/core";

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, config)
  .catch((err) => console.error(err));
